/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BulkFundingCard from 'app/components/BulkFundingCard/BulkFundingCard';
import { getBulkLoanNumberAction, getBulkSummaryList, getTNCPrivacyPolicy } from 'app/redux/actions/MarketplaceListAction';
import { IPagination } from 'app/redux/reducers/PortofolioReducer';
import { RootState } from 'app/redux/store';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-modal';
import customModalStyles from 'config/modal.config';
import './BulkMarketPlaceSummaryList.scss';
import modalBulkFundingConfirmationStyles from 'config/modalBulkFundingConfirmation.config';
import Button from 'app/components/Button/Button';
import modalDocument from 'config/modalDocument.config';
import ImagePath from 'app/utilities/imagePath';
import {
            downloadAgrementPDFAction,
            downloadLenderAgrementPDFAction,
            getLoanAgreementDocumentAction,
            IBulkLoanNumberResponse,
            submitBulkFundingAction,
            successBulkFundingAction
        } from 'app/redux/actions/FundingAction';
import { toast } from 'react-toastify';
import { IBulkSummaryList } from 'app/interfaces/marketplace/marketplace.interface';
import CheckPasswordModal from 'app/components/CheckPasswordModal/CheckPasswordModal';
import { getLenderSummaryHeaderAction } from 'app/redux/actions/PortofolioAction';
import { getTkbAction } from 'app/redux/actions/NavHeaderAction';

const paginationInit: IPagination = {
    totalData: 0,
    totalPage: 0,
    page: 1,
};

type ParamsType = {
    upload_secure_id: string;
    total_loan: string;
    total_loan_amount: string;
    loan_type_id: string;
};

const BulkMarketplaceSummaryList = function init(): React.ReactElement {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const marketplaceListState = useSelector((state: RootState) => state.marketplaceListReducer);
    const fundingState = useSelector((state: RootState) => state.fundingReducer);
    const headerState = useSelector((state: RootState) => state.portofolioReducer);
    const { bulkSummaryList, bulkSummaryPagination, bulkLoanNumber, dataTNCPrivacyPolicy } = marketplaceListState;
    const { isSuccessBulkFunding, urlLoanAgreement, agreementBase64, fundingLoading, urlLenderAgreement, lenderAgreementBase64 } = fundingState;
    const { lenderSummary } = headerState;
    const [localSummaryList, setLocalSummaryList] = useState<IBulkSummaryList[]>([]);
    const [localPagination, setLocalPagination] = useState(paginationInit);
    const [isBulkConfirmationModal, setIsBulkConfirmationModal] = useState(false);
    const [isModalAgreementOpen, setIsModalAgreementOpen] = useState(false);
    const [isModalSuccessFunding, setIsModalSuccessFunding] = useState(false);
    const [isModalCheckPassword, setIsModalCheckPassword] = useState(false);
    const [isLoading] = useState(false);
    const [disableButtonAgreement, setDisableButtonAgreement] = useState(true);
    const [disableCheckboxAgreement, setDisableCheckboxAgreement] = useState(true);
    const [activeTab, setActiveTab] = useState('ppfp');
    const [bulkLoanNumberList, setBulkLoanNumberList] = useState<IBulkLoanNumberResponse[]>([]);
    const [loanNumberIndex, setLoanNumberIndex] = useState(0);
    const [agreementList, setAgreementList] = useState<Blob[]>([]);
    const [PPFPList, setPPFPList] = useState<Blob[]>([]);
    const [dataTnc, setDataTnc] = useState('');
    const [invalid] = useState(false);
    const { upload_secure_id, total_loan, total_loan_amount, loan_type_id } = useParams<ParamsType>();
    const limit = 10;
    const loanFlag = 'web';

    const getDataList = () => {
        const nextPage = localPagination.page + 1;
        const payload = {
            limit,
            page: nextPage,
            flag: loanFlag,
            bulk_secure_id: upload_secure_id || ''
        };
        dispatch(getBulkSummaryList(payload));
    };

    function fetchLoanAgreement(): void {
        const getLenderUserId = localStorage.getItem('user');
		const userID = getLenderUserId ? JSON.parse(getLenderUserId).userId : '';
		const payload = {
			loanNumber: bulkLoanNumberList[loanNumberIndex]?.loan_number,
			lenderUserId: userID,
			amount: bulkLoanNumberList[loanNumberIndex]?.amount
		};
        dispatch(getLoanAgreementDocumentAction(payload));
    }

    useEffect(() => {
        const payload = {
            limit,
            page: 1,
            flag: loanFlag,
            bulk_secure_id: upload_secure_id || ''
        };
        const payloadLoanNumber = {
            bulk_secure_id: upload_secure_id || ''
        };
        dispatch(getTkbAction());
        dispatch(getLenderSummaryHeaderAction());
        dispatch(getBulkSummaryList(payload));
        dispatch(getBulkLoanNumberAction(payloadLoanNumber));
    }, []);

    function navigateToMarketplace(): void {
        navigate('/marketplace/list');
        dispatch(successBulkFundingAction(false));
    }

    function navigateToDashboard(): void {
        navigate('/dashboard/transaction-history');
        dispatch(successBulkFundingAction(false));
    }

    function isInsufficientBalance(): boolean {
        return lenderSummary.cashBalance < Number(total_loan_amount?.replace(/[Rp.,\s]/g, ''));
    }

    function onHandleConfirmation(): void {
        const payloadTNC = {
			category: 'TNC',
			key: 'GENERAL'
		};
        dispatch(getTNCPrivacyPolicy(payloadTNC));
        setIsBulkConfirmationModal(false);
        setIsModalAgreementOpen(true);

        if (loanNumberIndex === 0) {
            fetchLoanAgreement();
        }
    }
    function confirmationBulkFundingModal(): React.ReactElement {
        return (
            <div>
                <Modal
                    isOpen={isBulkConfirmationModal}
                    ariaHideApp={false}
                    style={modalBulkFundingConfirmationStyles}
                >
                    <div className="modal-bulk-funding-confirmation">
                        <div className="title">
                            Detail
                        </div>
                        <div className="description">
                            Apakah anda yakin akan mendanai
                        </div>
                        <div className="content-container">
                            <div>
                                <div className="label">
                                    Total Pinjaman
                                </div>
                                <div className="value">
                                    {total_loan_amount}
                                </div>
                            </div>
                            <div>
                                <div className="label">
                                    Jumlah Pinjaman
                                </div>
                                <div className="value">
                                    {total_loan}
                                </div>
                            </div>
                        </div>

                        <div className="button-container">
                            <button type="button" className="button-cancel" onClick={() => setIsBulkConfirmationModal(false)}>Batal</button>
                            <button type="button" className="button-confirm" onClick={() => onHandleConfirmation()}>Ya, Danai Pinjaman</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
    function handleTnc(): void {
		const wnd = window.open("about:blank", "", "_blank");
		if (wnd && dataTnc) {
			wnd.document.write(dataTnc);
			wnd.document.title = "Syarat & Ketentuan";
			// eslint-disable-next-line func-names
			wnd.onscroll = function () {
				if ((wnd.window.innerHeight + Math.round(wnd.window.scrollY)) >= wnd.document.body.offsetHeight) {
					setDisableCheckboxAgreement(false);
				}
			};
		}
	}
    function successFundingModal(): React.ReactElement {
        return (
            <div>
                <Modal
                    isOpen={isModalSuccessFunding}
                    ariaHideApp={false}
                    style={customModalStyles}
                >
                    <div className="success-funding-modal">
                        <img src={ImagePath.processing.src} alt={ImagePath.processing.alt} />
                        <div className="title">
                            Pendanaan Diproses
                        </div>
                        <div className="description">
                            Kami sedang memproses
                            &nbsp;
                            {total_loan}
                            &nbsp;
                            pendanaan yang telah Anda ajukan dengan total nilai sebesar
                            &nbsp;
                        </div>
                        <div className="amount">
                            {total_loan_amount}
                        </div>
                        <div className="info">
                            Proses ini mungkin memakan waktu beberapa saat, dan Anda akan menerima notifikasi setelah pendanaan berhasil diselesaikan
                        </div>
                        <button type="button" className="button-confirm" onClick={() => navigateToDashboard()}>Lihat Progress Pendanaan</button>
                        <button type="button" className="button-cancel" onClick={() => navigateToMarketplace()}>Kembali ke Marketplace</button>
                    </div>

                </Modal>
            </div>
        );
    }

    function onHandleSubmitAgreement(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        setIsModalAgreementOpen(false);
        setIsModalCheckPassword(true);
    }

    function onHandleSubmitFunding(): void {
        const payload = {
            loan_bulk_upload_group_id: upload_secure_id || '',
            loan_type_secure_id: loan_type_id || '',
        };
        dispatch(submitBulkFundingAction(payload));
    }

    function renderPDWViewer() : ReactElement {
		const agreementStyling = {
			marginBottom: '36px',
			height: '500px',
			backgroundColor: '#F3F8FC',
			color: 'black'
		};
		let getUrlFromBlob;
		const removeToolbarPDF = '#toolbar=0&navpanes=0&scrollbar=0';
		if (agreementList[loanNumberIndex] && PPFPList[loanNumberIndex] && activeTab === 'ppfp') {
            getUrlFromBlob = URL.createObjectURL(PPFPList[loanNumberIndex]);
		}
        if (agreementList[loanNumberIndex] && PPFPList[loanNumberIndex] && activeTab === 'pp') {
            getUrlFromBlob = URL.createObjectURL(agreementList[loanNumberIndex]);
		}
		return (
			<div className="previewAgreement" style={agreementStyling}>
			<object data={getUrlFromBlob + removeToolbarPDF} type="application/pdf" width="100%" height="100%">
				<p>
					<a href={getUrlFromBlob + removeToolbarPDF}>to the PDF!</a>
				</p>
			</object>
			</div>
		);
	}
    const handleChangeCheckbox = (e) : void => {
		if (e.target.checked === true) {
			setDisableButtonAgreement(false);
		} else {
			setDisableButtonAgreement(true);
		}
	};

    function renderTabComponent(): React.ReactElement {
        return (
            <div className="tab-wrapper">
                <button
                type="button"
                className={`tab ${activeTab === 'ppfp' ? 'active' : ''}`}
                onClick={() => setActiveTab('ppfp')}
                >
                    Perjanjian Pemberian Fasilitas Pendanaan
                </button>
                <button
                    type="button"
                    className={`tab ${activeTab === 'pp' ? 'active' : ''}`}
                    onClick={() => setActiveTab('pp')}
                >
                    Perjanjian Pendanaan
                </button>
            </div>
        );
    }

    function agreementModal(): React.ReactElement {
		const headerStyling = {
			paddingBottom: '40px',
		};
		const buttonStyling = {
			width: '464px',
			margin: '0 auto'
		};
		const checkboxStyling = {
			marginRight: '19px',
		};
		return (
			<div>
				<Modal
					isOpen={isModalAgreementOpen}
					ariaHideApp={false}
					style={modalDocument}
				>
                    <div className="agreement-container">
                        <div className="titleContainer" style={headerStyling}>
                            <h3>Preview Agreement</h3>
                            <button
                                className="imageContainer btn"
                                type="button"
                                disabled={isLoading}
                                onClick={() => setIsModalAgreementOpen(false)}
                            >
                                <img src={ImagePath.close.src} alt={ImagePath.close.alt} />
                            </button>
                        </div>
                        {renderTabComponent()}
                        {renderPDWViewer()}

                        <div className="pagination-container">
                            <span className="pagination-text">
                                {loanNumberIndex + 1}
                                /
                                {bulkLoanNumberList.length}
                            </span>
                        </div>
                        <div>
                            <input type="checkbox" id="agreement" style={checkboxStyling} onChange={handleChangeCheckbox} disabled={disableCheckboxAgreement} />
                            <span>Saya telah membaca dan menyetujui </span>
                            <button type="button" id="tnc_link" onClick={() => handleTnc()}>Syarat & Ketentuan</button>
                            <span> yang berlaku</span>
                        </div>
                        <div style={buttonStyling}>
                            <form onSubmit={onHandleSubmitAgreement}>
                                <Button
                                    disabled={disableButtonAgreement ? true : invalid}
                                    buttonText={isLoading ? "Proses Pendanaan" : "Danai"}
                                    loading={isLoading}
                                />
                            </form>
                        </div>
                        <div className="navigation-container">
                            <button
                                type="button"
                                disabled={loanNumberIndex === 0 || fundingLoading}
                                onClick={() => setLoanNumberIndex(loanNumberIndex - 1)}
                            >
                                <img src={ImagePath.arrowLeft.src} alt={ImagePath.arrowLeft.alt} />
                            </button>
                            <button
                                type="button"
                                disabled={loanNumberIndex === bulkLoanNumberList.length - 1 || fundingLoading}
                                onClick={() => setLoanNumberIndex(loanNumberIndex + 1)}
                            >
                                <img src={ImagePath.arrowRight.src} alt={ImagePath.arrowRight.alt} />
                            </button>
                        </div>
                    </div>
				</Modal>
			</div>
		);
	}

    function checkPasswordModal(): React.ReactElement {
        return (
        <Modal
        isOpen={isModalCheckPassword}
        ariaHideApp={false}
        style={modalBulkFundingConfirmationStyles}
        >
            <CheckPasswordModal
                setOpenModal={setIsModalCheckPassword}
                isOpenModal={isModalCheckPassword}
                action={() => onHandleSubmitFunding()}
            />
        </Modal>
        );
    }

    function onSubmitFloatingMenu(): void {
        if (isInsufficientBalance()) {
            toast.error("Cash balance anda tidak mencukupi");
        } else {
            setIsBulkConfirmationModal(true);
        }
    }

    function floatingMenu(): React.ReactElement {
        return (
            <div className="floating-menu">
                <div className="d-flex">
                    <span>
                        {total_loan}
                        &nbsp;
                        Pendanaan Pinjaman&nbsp;
                        <strong>
                        Total&nbsp;
                        {total_loan_amount}
                        </strong>
                    </span>
                </div>
                <button type="button" className="button-funding" onClick={() => onSubmitFloatingMenu()}>Danai Pinjaman</button>
            </div>
        );
    }

    useEffect(() => {
		if (dataTNCPrivacyPolicy) {
			setDataTnc(dataTNCPrivacyPolicy[0]?.description);
		}
	}, [dataTNCPrivacyPolicy]);

    useEffect(() => {
        setLocalPagination(bulkSummaryPagination);
        if (bulkSummaryList.length === 0 || bulkSummaryPagination.page === 1) {
            setLocalSummaryList([]);
        }
        if (bulkSummaryPagination.page === 1 && bulkSummaryList.length > 0) {
            setLocalSummaryList(bulkSummaryList);
        } else {
            setLocalSummaryList((prev) => {
                const newItems = bulkSummaryList.filter((item) => !prev.some((existing) => existing.secure_id === item.secure_id));
                return [...prev, ...newItems];
            });
        }
    }, [bulkSummaryList]);

    useEffect(() => {
        if (isSuccessBulkFunding) {
            setIsModalAgreementOpen(false);
            setIsModalCheckPassword(false);
            setIsModalSuccessFunding(true);
        }
    }, [isSuccessBulkFunding]);

    useEffect(() => {
        if (bulkLoanNumber) {
            setBulkLoanNumberList(bulkLoanNumber);
        }
    }, [bulkLoanNumber]);

    useEffect(() => {
        if (bulkLoanNumberList.length > 0 && !agreementList[loanNumberIndex] && loanNumberIndex !== 0) {
            fetchLoanAgreement();
        }
    }, [loanNumberIndex, bulkLoanNumberList]);

    useEffect(() => {
		if (urlLoanAgreement && !agreementList[loanNumberIndex]) {
		try {
			dispatch(downloadAgrementPDFAction({
				document_url: urlLoanAgreement
			}));
		} catch (err) {
			toast.error("Mohon maaf terjadi kesalahan. Coba beberapa saat lagi.");
		}
		}
	}, [urlLoanAgreement]);

    useEffect(() => {
		if (urlLenderAgreement && !PPFPList[loanNumberIndex]) {
		try {
			dispatch(downloadLenderAgrementPDFAction({
				document_url: urlLenderAgreement
			}));
		} catch (err) {
			toast.error("Mohon maaf terjadi kesalahan. Coba beberapa saat lagi.");
		}
		}
	}, [urlLenderAgreement]);

    useEffect(() => {
		if (agreementBase64) {
			setAgreementList([...agreementList, agreementBase64]);
		}
	}, [agreementBase64]);

    useEffect(() => {
		if (lenderAgreementBase64) {
			setPPFPList([...PPFPList, lenderAgreementBase64]);
		}
	}, [lenderAgreementBase64]);

    window.onscroll = () => {
        if (
            (Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight)
            &&
            (localPagination.page < bulkSummaryPagination.totalPage)
        ) {
            if (bulkSummaryList.length < bulkSummaryPagination.totalData) {
                getDataList();
            }
        }
    };

    return (
        <div className="width-100">
            <button type="button" onClick={() => navigate('/marketplace/list')} className="back-to-marketplace">
                <img src={ImagePath.arrowLeft.src} alt={ImagePath.arrowLeft.alt} />
                Marketplace
            </button>
            <div className="partner-name">{localSummaryList[0]?.partner_name}</div>
            <div style={{ width: '100%', marginBottom: '54px' }}>
                { localSummaryList.map((item) => (
                    <div key={item.secure_id}>
                        <BulkFundingCard fundingData={item} />
                    </div>
                ))}
                { !isModalAgreementOpen && floatingMenu()}
                { confirmationBulkFundingModal()}
                { agreementModal() }
                { checkPasswordModal() }
                { successFundingModal() }
            </div>
        </div>
    );
};

export default BulkMarketplaceSummaryList;
